import { render, staticRenderFns } from "./CustomMenu.vue?vue&type=template&id=79e1bf3e&scoped=true"
import script from "./CustomMenu.vue?vue&type=script&lang=js"
export * from "./CustomMenu.vue?vue&type=script&lang=js"
import style0 from "./CustomMenu.vue?vue&type=style&index=0&id=79e1bf3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e1bf3e",
  null
  
)

export default component.exports